import React from "react";
import PropTypes from "prop-types";

/**
 * Custom content template for react-s-alert that adds customFields.customClass
 * to the alert box so we can style specific alerts (e.g. selection-limit-alert).
 */
function SAlertContentTemplate(props) {
  const customClass = props.customFields?.customClass
    ? ` ${props.customFields.customClass}`
    : "";
  const classNames = (props.classNames || "") + customClass;

  return (
    <div
      className={classNames}
      id={props.id}
      style={props.styles}
    >
      <div className="s-alert-box-inner">{props.message}</div>
      <span
        className="s-alert-close"
        onClick={props.handleClose}
        onKeyDown={(e) => e.key === "Enter" && props.handleClose()}
        role="button"
        tabIndex={0}
        aria-label="Cerrar"
      />
    </div>
  );
}

SAlertContentTemplate.propTypes = {
  id: PropTypes.string.isRequired,
  classNames: PropTypes.string.isRequired,
  condition: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  handleClose: PropTypes.func.isRequired,
  customFields: PropTypes.object,
};

export default SAlertContentTemplate;
